import type { Profile } from '@api/models';
import posthog from 'posthog-js';
import { nextTick } from 'vue';

import { maskEmail, maskWords } from '@stuut/common/src/utils';

import router from '@/router';

export default {
  install(app) {
    if (process.env.NODE_ENV !== 'production' || !process.env.STUUT_POSTHOG) {
      return;
    }

    app.config.globalProperties.$posthog = posthog.init(process.env.STUUT_POSTHOG, {
      api_host: 'https://us.i.posthog.com',
      capture_pageview: false,
      before_send: (event) => {
        const exceptions = event?.properties?.$exception_list ?? [];
        if (
          exceptions.some(
            (ex: any) => typeof ex?.value === 'string' && ex.value.includes('ResizeObserver'),
          )
        ) {
          return null;
        }
        return event;
      },
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: {
          password: true,
        },
      },
    });

    router.afterEach((to, from, failure) => {
      if (!failure) {
        nextTick(() => {
          app.config.globalProperties.$posthog?.capture('$pageview', {
            path: to.fullPath,
          });
        });
      }
    });
  },
};

export const identifyUser = (profile?: Profile) => {
  if (process.env.NODE_ENV !== 'production' || !process.env.STUUT_POSTHOG || !profile?.id) {
    return;
  }

  posthog.identify(profile.id, {
    email: maskEmail(profile.email),
    // @ts-ignore
    environment: process.env.NODE_ENV,
    isAccessApproved: profile.is_access_approved,
    isAdmin: profile.is_org_admin,
    isEmailVerified: profile.is_email_verified,
    isSupportUser: profile.is_support_user,
    name: maskWords([profile.given_name, profile.family_name]),
    organization: profile.organization?.name,
    organizationId: profile.organization_id || profile.organization?.id,
    // @ts-ignore
    release: window?.app?.__vue_app__?.version,
  });

  if (profile.organization?.name === 'logrocket') {
    posthog.opt_out_capturing();
  } else if (profile.is_support_user || profile.organization?.name === 'stuut') {
    posthog.setInternalOrTestUser();
  }
};
